import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';

export default function Page14({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<RoundScreen
				title='Exercise 06 Dumbbell Curls'
				rounds={[
					[
						{
							header: 'Exercise',
							value: 'Seated Dumbbell Curls',
						},
						{
							header: '# of sets',
							value: '1',
						},
						{
							header: 'REPS / Weight',
							value: '8 - 12 Light',
						},
						{
							header: 'MINDSET/ FOCUSES INSTRUCTIONS',
							value: 'Warm Up, “Blood Flow”, SQUEEZE',
						},
					],
					[
						{
							header: 'Exercise',
							value: 'Seated Dumbbell Curls',
						},
						{
							header: '# of sets',
							value: '2 - 3',
						},
						{
							header: 'REPS / Weight',
							value: '8 - 10 Mild - Heavy',
						},
						{
							header: 'MINDSET/ FOCUSES INSTRUCTIONS',
							value: 'Working Set, Full Contraction',
						},
					],
					[
						{
							header: 'Exercise',
							value: 'Seated Dumbbell Curls',
						},
						{
							header: '# of sets',
							value: '4',
						},
						{
							header: 'REPS / Weight',
							value: 'Mild - Heavy',
						},
						{
							header: 'MINDSET/ FOCUSES INSTRUCTIONS',
							value: 'Full On Set (Burn Out)',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
